export default __webpack_public_path__ + "static/iPhone 15 Pro Max - Natural Titanium - Portrait-52a75a77c8a9dec885c131d3a9a2fbce.png";